type Props = {
  children: React.ReactNode;
};

const BlankLayout = ({ children }: Props) => children;

export default BlankLayout;
